import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateDeclaracionTrabajadorCuentaPropia = () => {
  const [loadingCreateDeclaracionTrabajadorCuentaPropia, setLoadingCreateDeclaracionTrabajadorCuentaPropia] = useState(false);
  const [successCreateDeclaracionTrabajadorCuentaPropia, setSuccessCreateDeclaracionTrabajadorCuentaPropia] = useState(false);
  const [errorCreateDeclaracionTrabajadorCuentaPropia, setErrorCreateDeclaracionTrabajadorCuentaPropia] = useState(null);
  const [dataCreateDeclaracionTrabajadorCuentaPropia, setDataDeclaracionTrabajadorCuentaPropia] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // CREATE
  const createDeclaracionTrabajadorCuentaPropia = async (
    userId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreateDeclaracionTrabajadorCuentaPropia(true);
    setSuccessCreateDeclaracionTrabajadorCuentaPropia(false);
    setErrorCreateDeclaracionTrabajadorCuentaPropia(null);

    apiRecord.newDeclaracionTrabajadorCuentaPropia(userId, data)
      .then((res: any) => {
        setLoadingCreateDeclaracionTrabajadorCuentaPropia(false);
        setSuccessCreateDeclaracionTrabajadorCuentaPropia(true);
        setDataDeclaracionTrabajadorCuentaPropia(res.data);
        _cb?.(res.data);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreateDeclaracionTrabajadorCuentaPropia(false);
        setErrorCreateDeclaracionTrabajadorCuentaPropia(err.response?.data);
      });
  };

  return {
    createDeclaracionTrabajadorCuentaPropia,
    loadingCreateDeclaracionTrabajadorCuentaPropia,
    successCreateDeclaracionTrabajadorCuentaPropia,
    errorCreateDeclaracionTrabajadorCuentaPropia,
    dataCreateDeclaracionTrabajadorCuentaPropia
  };
};

export default useCreateDeclaracionTrabajadorCuentaPropia;
